import Version from "./version/version";

class VersionUtil {
    private _version: Version = new Version(); 

    get version() { return this._version.version }
    get build() { return this._version.build }
    get suffix() { return this._version.suffix }

    getVersion(n: number = 4) {
        if (n === 4) {
            return `${this.version}.${this.build}` + (this.suffix ? ` ${this.suffix}` : '');
        }
        else if (n === 3) {
            return this.version;
        }
        else {
            return this.version.split('.').slice(0, n).join('.');
        }
    }
}

export default new VersionUtil();